import { computed } from 'vue';
import { NavigationGuard } from 'vue-router';
import { AuthClient, AuthConfig } from '@repo/core/security';
import { MessageConstants } from '@repo/core/constants';
import { ResourceConfig } from '@repo/core/resources';
import { useDxMessage } from '@repo/vue/utils';

const authClient = new AuthClient(AuthConfig);

export const authGuard: NavigationGuard = async (to) => {
  // guard
  const user = await authClient.getUser();
  if (user && !user.expired) return true;

  // data
  const isIFrame = computed(() => window.self !== window.top);
  const target = computed(() => window.parent);

  // methods
  if (isIFrame.value) {
    const dxMessage = useDxMessage(target, ResourceConfig.webAngularUrl);
    const message: any = {
      event: MessageConstants.login
    };
    dxMessage.sendMessage(message);
  } else {
    await authClient.loginWithRedirect({
      state: { target: to.fullPath }
    });
  }

  return false;
};
